import React from 'react'
import { useTypedTranslation } from 'app/modules/shared/hooks/use-translation'
import { ObjectRows, parseHumanFileSize } from '../../helpers'
import { useExport } from '../../contexts'
import { ContentCard } from '../content-card'
import { FileContentModalViewer } from '../file-content-viewer/file-content-viewer'

export function DefaultOverviewBySections({ data }: { [key: string]: any }) {
  const { _t } = useTypedTranslation()
  const exporting = useExport()
  const overview = { ...data }
  const grouped: { [key: string]: any } = {
    'file-details': {},
    hashes: {},
    visualization: {},
  }
  const sha256 = overview['SHA-256']
  const fileSize = overview?.size && parseHumanFileSize(overview.size)
  const hashes = ['MD5', 'SHA-1', 'SHA-256', 'SHA-512', 'imphash', 'fsiofuzzyhash', 'authentihash', 'ssdeep']
  let viewContentTab = 'file-details'

  // Extract isFileAvailable flag, then remove it to prevent showing in details
  const fileAvailable = overview['isFileAvailable']
  delete overview['isFileAvailable']

  for (const name of hashes) {
    if (typeof overview[name] !== 'undefined') {
      grouped['hashes'][name] = overview[name]
      delete overview[name]
    }
  }

  if (typeof overview.visualization !== 'undefined') {
    grouped.visualization.image = overview.visualization
    delete overview.visualization
    viewContentTab = 'visualization'
  }

  grouped['file-details'] = overview

  return (
    <div className="overview-by-sections d-flex flex-column gap-y-4">
      {Object.keys(grouped).map((groupName, idx) => {
        const values = grouped[groupName]
        if (!Object.keys(values).length) {
          return null
        }

        return (
          <ContentCard key={idx.toString()} title={_t(groupName)}>
            <ObjectRows object={values} enableCopy={false} checkHash={!exporting} lengthLimit={64} />

            {groupName === viewContentTab ? (
              <div className="mt-4">
                <FileContentModalViewer
                  key={sha256}
                  sha256={sha256}
                  modalTitle={_t('file-content')}
                  language={data.overview?.language}
                  fileSize={fileSize}
                  isPrivate={!fileAvailable}
                />
              </div>
            ) : null}
          </ContentCard>
        )
      })}
    </div>
  )
}
